import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { FormikProps } from "formik";

import Grid2 from "@mui/material/Grid2"; // استفاده از Grid2

// ساخت schema برای اعتبارسنجی با yup

const CityForm = ({ formik }: { formik: FormikProps<any> }) => {
  return (
    <Grid2 container spacing={1} marginBottom={1} padding={0.8}>
      {/* فیلد شناسه فرم */}
      <Grid2 size={12}>
        <TextField
          {...formik.getFieldProps("name")} // استفاده از ویژگی‌های فرمیک
          label="نام شهر"
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={(formik.touched.name && formik.errors.name) as boolean}
          variant="outlined"
          fullWidth
        />
      </Grid2>
      <Grid2 size={6}>
        <TextField
          {...formik.getFieldProps("lat")} // استفاده از ویژگی‌های فرمیک
          label="Lat"
          error={formik.touched.lat && Boolean(formik.errors.lat)}
          helperText={(formik.touched.lat && formik.errors.lat) as boolean}
          variant="outlined"
          fullWidth
        />
      </Grid2>
      <Grid2 size={6}>
        <TextField
          {...formik.getFieldProps("long")} // استفاده از ویژگی‌های فرمیک
          label="Long"
          error={formik.touched.long && Boolean(formik.errors.long)}
          helperText={(formik.touched.long && formik.errors.long) as boolean}
          variant="outlined"
          fullWidth
        />
      </Grid2>
    </Grid2>
  );
};

export default CityForm;
